// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3cwct","content":"ManualTimeModal_content__yFkeB"};